import * as z from "zod";

// Self-serve /welcome/chargebacks notifies sales of picked modules + migration
// provider. Insights is always-on, so it's implicit and never sent.
export const recordChargebackOnboardingSelection = {
  name: "recordChargebackOnboardingSelection" as const,
  input: z
    .object({
      modules: z.array(z.enum(["reclaim", "alerts", "resolve"])),
      migrationProvider: z.string().max(200).optional(),
    })
    .refine(
      (data) => data.modules.length > 0 || !!data.migrationProvider?.trim(),
      { message: "Provide at least one module or a migration provider" },
    ),
  output: z.null(),
};
